"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var createEnhancer_1 = tslib_1.__importStar(require("react-universal-interface/lib/createEnhancer"));
exports.divWrapper = createEnhancer_1.divWrapper;
exports.default = createEnhancer_1.default;
//# sourceMappingURL=faccToHoc.js.map